module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalBase', {
    attrs: {
      "id": "campaign-selector",
      "minWidth": '80%',
      "maxWidth": '80%',
      "flex": false
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (_vm.listCampaigns.length !== 0) ? _c('h1', {
    staticClass: "ff-light title-modal"
  }, [_vm._v(_vm._s(_vm.$t("menuHeader.selectCampaign")))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flexContainer logoContainer fd-r fw-w m-jc-sb"
  }, [(_vm.listCampaigns.length !== 0) ? _c('div', {
    directives: [{
      name: "setUserInfo",
      rawName: "v-setUserInfo.currentCampaignId",
      value: (0),
      expression: "0",
      modifiers: {
        "currentCampaignId": true
      }
    }],
    staticClass: "brandWrap flexContainer jc-c fd-c size1of4 pointer",
    on: {
      "click": function($event) {
        _vm.selectAllCampaign();
      }
    }
  }, [_c('p', {
    staticClass: "brandLogo txtCenter ff-medium uppercase vCenter"
  }, [_vm._v(_vm._s(_vm.$t("catalogue.allCampaign")))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listCampaigns), function(camp) {
    return _c('div', {
      directives: [{
        name: "setUserInfo",
        rawName: "v-setUserInfo.currentCampaign",
        value: (camp.name),
        expression: "camp.name",
        modifiers: {
          "currentCampaign": true
        }
      }, {
        name: "setUserInfo",
        rawName: "v-setUserInfo.campaignShort",
        value: (camp.shortName),
        expression: "camp.shortName",
        modifiers: {
          "campaignShort": true
        }
      }, {
        name: "setUserInfo",
        rawName: "v-setUserInfo.currentCampaignId",
        value: (camp.id),
        expression: "camp.id",
        modifiers: {
          "currentCampaignId": true
        }
      }],
      key: camp.id,
      staticClass: "brandWrap flexContainer jc-c fd-c size1of4 pointer",
      on: {
        "click": function($event) {
          _vm.selectCampaign(camp);
        }
      }
    }, [_c('p', {
      staticClass: "brandLogo txtCenter ff-medium uppercase",
      class: [_vm.currentCampaign.id == camp.id ? 'active' : '_notselectedCampaign', '']
    }, [_vm._v("\n                " + _vm._s(camp.name) + "\n            ")])])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90043cbe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ModalCampaign.vue
// module id = 3313
// module chunks = 0